const symbolMapper = {
  bitgem: "BTG ",
  bytom: "BTM ",
  adcoin: "ACC ",
  "arcade-token": "ARC ",
  batcoin: "BAT ",
  betacoin: "BET ",
  "bitcoin-scrypt": "BTCS ",
  cashcoin: "CASH ",
  catcoin: "CAT ",
  encryptotel: "ETT ",
  guccionecoin: "GCC ",
  huncoin: "HNC ",
  iconomi: "ICN ",
  "kingn-coin": "KNC ",
  mergecoin: "MGC ",
  mantracoin: "MNC ",
  netcoin: "NET ",
  rcoin: "RCN ",
  remicoin: "RMC ",
  smartcash: "SMART ",
  "sphre-air": "XID ",
  game: "GTC ",
  bitclave: "CAT  ",
  eternity: "ENT ",
  mixin: "XIN ",
  "wi-coin": "WIC ",
  capricoin: "CPC ",
  holo: "HOT ",
  hero: "HERO ",
  "origin-sport": "ORS ",
  hold: "HOLD ",
  ong: "ONG ",
  webcoin: "WEB ",
  ratecoin: "XRA ",
  pchain: "PAI ",
  edgeware: "EDG ",
};

export default function mapper(coin) {
  return Object.assign(coin, { symbol: symbolMapper[coin.id] || coin.symbol });
}
